import auth from '@/mixins/auth'
import localStorage from 'store'

export default {
  mixins: [auth],
  data: function () {
    return {
      themeMode: 'light'
    }
  },
  watch: {
    isLoggedIn: function () {
      this.checkTheme()
    }
  },
  mounted: function () {
    this.checkTheme()
  },
  computed: {
    showThemeToggle: function () {
      if (this.enabledSites && this.isAdmin) {
        return true
      } else {
        return false
      }
    },
    enabledSites: function () {
      return this.$isMake || this.$isEngCom || this.$isProjectboard
    }
  },
  methods: {
    setTheme: function (theme) {
      document.documentElement.setAttribute('data-theme', theme)
      localStorage.set('theme', theme)
      this.themeMode = theme
    },
    saveTheme: function (selectedTheme) {
      if (!selectedTheme) {
        return
      }
      if (this.isLoggedIn) {
        const settings = { theme: selectedTheme }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
        this.setTheme(selectedTheme)
      } else {
        this.setTheme(selectedTheme)
      }
    },
    checkTheme: function () {
      if (!this.enabledSites) {
        this.setTheme('light')
        return
      }
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'theme').then((theme) => {
          this.setTheme(theme)
        })
      } else {
        const themeSetting = localStorage.get('theme')
        if (themeSetting) {
          this.setTheme(themeSetting)
        } else {
          this.setTheme(this.themeMode)
        }
      }
    },
    toggleThemeMode: function () {
      if (this.themeMode === 'light') {
        this.themeMode = 'dark'
      } else {
        this.themeMode = 'light'
      }
      this.saveTheme(this.themeMode)
    }
  }
}
